<template>
    <div class="d-flex align-items-stretch">
        <navigation></navigation>
        <div class="container-fluid main-content page-content">
            <preloader-placeholder :loading="loading" :type="'configuration'"></preloader-placeholder>
            <div v-if="loading === false">
                <div class="page-header">
                    <h3 class="page-title">{{$t('config-telnyx-connector')}}</h3>
                </div>
                <sms-number-to-activate v-if="numberToActivate"/>
                <active-telnyx v-else/>
            </div>
           <template v-if="numberToActivate === null">
               <SmsInfoPlus></SmsInfoPlus>
            </template>
        </div>
    </div>
</template>
<script>

// Internal components
import PreloaderPlaceholder from '@/core/components/PreloaderPlaceholder.vue';
import ActiveTelnyx         from './ActiveTelnyx.vue';
import SmsNumberToActivate  from './SmsNumberToActivate.vue';
import SmsInfoPlus          from '../SmsInfoPlus.vue';

// Import external libraries
import {
    mapState, mapActions, mapGetters
} from 'vuex';

export default {
    components: {
        ActiveTelnyx,
        SmsNumberToActivate,
        PreloaderPlaceholder,
        SmsInfoPlus
    },

    data () {
        return {
            loading:       true,
            nameConnector: 'telnyx'
        };
    },

    computed: {
        // State with activated phone number
        ...mapState('core/number', [
            'phoneNumber'
        ]),

        // Getter for the selected number
        ...mapGetters('core/number', {
            numberGetter:     'smsPhoneNumber',
            numberToActivate: 'numberToActivate'
        })
    },
    mounted () {
        this.nameConnector = window.location.href.split('/')[5];
        this.listNumber().then(() => {
            this.loading = false;
            this.numberGetter;
        });
    },
    methods: {
        // Method get list of activated number
        ...mapActions('core/number', { listNumber: 'index' })
    }
};
</script>
